import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { InfoMessagesComponent } from '@shared/components/header/info-messages/info-messages.component';
import { MenuFooterComponent } from '@shared/components/header/menu-footer/menu-footer.component';
import { MenuGroupComponent } from '@shared/components/header/menu-group/menu-group.component';
import { UserMenuComponent } from '@shared/components/header/user-menu/user-menu.component';
import { EopButtonModule } from '@widgets/eop-button/eop-button.module';
import { WidgetModule } from '@widgets/widgets.module';
import { GlobalHeaderComponent } from './global-header/global-header.component';
import { HeaderMenuComponent } from './header-menu/header-menu.component';
import { LinkElementComponent } from './link-element/link-element.component';
import { EopStationSearchFieldComponent } from './quick-access/eop-station-search-field/eop-station-search-field.component';
import { QuickAccessModule } from './quick-access/quick-access.module';
import { ShowNotificationModule } from './show-notification/show-notification.module';
import { SimpleLinkElementComponent } from './simple-link-element/simple-link-element.component';

@NgModule({
  imports: [
    CommonModule,
    WidgetModule,
    RouterModule,
    MatExpansionModule,
    MatTooltipModule,
    ShowNotificationModule,
    QuickAccessModule,
    EopButtonModule,
    NgOptimizedImage,
  ],
  declarations: [
    GlobalHeaderComponent,
    HeaderMenuComponent,
    LinkElementComponent,
    UserMenuComponent,
    MenuFooterComponent,
    MenuGroupComponent,
    SimpleLinkElementComponent,
    InfoMessagesComponent,
    EopStationSearchFieldComponent,
  ],
  exports: [GlobalHeaderComponent, LinkElementComponent, EopStationSearchFieldComponent],
})
export class HeaderModule {}
